import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { PatoisMarquee } from "@/components/PatoisMarquee";

export default function About() {
  return (
    <div data-testid="about-page" className="pt-20">
      <section className="relative grain overflow-hidden">
        <div className="absolute inset-0">
          <img src="https://static.prod-images.emergentagent.com/jobs/7d4b1824-6f94-4ced-ae91-4ba211ce6db0/images/4f7902e6257517f38d42443234b7b8e3f2c89eb7ab677af3a8dcd46231855467.jpeg" alt="Turahtid streetwear" className="w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-t from-background via-background/70 to-background/40" />
        </div>
        <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center">
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-jamaica-green mb-4">Talented · Unique · Rebel</p>
          <h1 className="font-display text-5xl sm:text-7xl tracking-tight leading-none">
            WE NUH FOLLOW.<br /><span className="text-jamaica-gold">WE LEAD.</span>
          </h1>
        </div>
      </section>

      <PatoisMarquee />

      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 space-y-8">
        <div>
          <h2 className="font-display text-3xl sm:text-4xl tracking-tight mb-3">DI ROOTS</h2>
          <p className="text-zinc-300 leading-relaxed">
            Turahtid Clothing was born in the heart of Kingston, out of one simple truth — our language is our
            identity. Every phrase we print carries generations of Jamaican voice: the greetings, the wisdom,
            the raw humour, the rebellion. This isn't costume culture. This is <span className="text-jamaica-gold">real patois, worn with pride.</span>
          </p>
        </div>
        <div>
          <h2 className="font-display text-3xl sm:text-4xl tracking-tight mb-3">DI CRAFT</h2>
          <p className="text-zinc-300 leading-relaxed">
            Heavyweight cotton. Puff prints, gold foil, breathable mesh jerseys. We build tees that survive the
            road, the party, and the wash cycle. Talented in design. Unique in message. Rebel in spirit — every
            drop is limited, so when it gone, it gone.
          </p>
        </div>
        <div>
          <h2 className="font-display text-3xl sm:text-4xl tracking-tight mb-3">FI DI PEOPLE</h2>
          <p className="text-zinc-300 leading-relaxed">
            From Kingston to the diaspora worldwide, Turahtid is for anyone who feels the culture. Out ah many,
            one people — one wardrobe, one voice. Wear it loud.
          </p>
        </div>

        <div className="grid grid-cols-3 gap-3">
          {[
            "https://static.prod-images.emergentagent.com/jobs/7d4b1824-6f94-4ced-ae91-4ba211ce6db0/images/249725f973b1bc90762d386e160eb714f20a4b01aceb6b70d86f04b583c2494e.jpeg",
            "https://static.prod-images.emergentagent.com/jobs/7d4b1824-6f94-4ced-ae91-4ba211ce6db0/images/f0089cd25a3159849db71fa2410ad42de7c55b5fec925021e8763f42e488354c.jpeg",
            "/brand/greatness-pair.jpg",
          ].map((img, i) => (
            <div key={i} className="aspect-square overflow-hidden border border-white/10 bg-zinc-900">
              <img src={img} alt="" loading="lazy" className="w-full h-full object-cover" />
            </div>
          ))}
        </div>

        <div className="text-center pt-4">
          <Link to="/shop">
            <Button className="px-10 py-6 bg-jamaica-gold hover:bg-yellow-300 text-black font-bold uppercase tracking-widest rounded-none">
              Shop Di Collection
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
}
